import { render } from "./ProdutoPage.vue?vue&type=template&id=1183a67a&scoped=true"
import script from "./ProdutoPage.vue?vue&type=script&lang=js"
export * from "./ProdutoPage.vue?vue&type=script&lang=js"

import "./ProdutoPage.vue?vue&type=style&index=0&id=1183a67a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1183a67a"]])

export default __exports__